<div class="fixed inset-0 z-50 flex items-center justify-center">
  <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" (click)="close()"></div>
  <div
    class="relative z-10 w-[320px] rounded-2xl overflow-hidden border border-border-glass shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
    style="background: linear-gradient(180deg, rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0.06))"
  >
    <div class="flex items-center justify-between px-4 py-3 border-b border-border-glass">
      <span class="font-semibold text-text-primary text-sm">QR-Code scannen</span>
      <button type="button" (click)="close()" class="text-text-muted hover:text-text-primary transition-colors">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="scanner-wrapper w-full aspect-square">
      <video #scannerVideo playsinline autoplay muted></video>
    </div>
  </div>
</div>
